import { render, staticRenderFns } from "./DueInvoices.vue?vue&type=template&id=dd983ae6&"
import script from "./DueInvoices.vue?vue&type=script&lang=js&"
export * from "./DueInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports